<template>
  <v-row class="ma-1">
    <v-col cols="12" md="4" v-show="isVisible('umidade')">
      <label>
        Há umidade no local?
      </label>
      <v-radio-group row v-model="dados.umidade.$model" :error-messages="umidadeErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('eventoClimatico')">
      <label>
        Houve evento climático recente?
      </label>
      <v-radio-group row v-model="dados.eventoClimatico.$model" :error-messages="eventoClimaticoErrors">
        <v-radio label="Chuva intensa" value="Chuva"></v-radio>
        <v-radio label="Granizo" value="Granizo"></v-radio>
        <v-radio label="Ventos fortes" value="Ventos"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('energizadoMomentoFalha')">
      <label>
        Equipamento estava operando no momento da falha?
      </label>
      <v-radio-group row v-model="dados.energizadoMomentoFalha.$model" :error-messages="energizadoMomentoFalhaErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
        <v-radio label="Não sei" value="Não sei"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="4" v-show="isVisible('sinalizacaoFalha')">
      <label for="">Há sinalização de falha? (código / LED)
      </label>
      <v-radio-group v-model="dados.sinalizacaoFalhaLocal.$model" row :error-messages="sinalizacaoFalhaLocalErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
        <v-radio label="Não verificado" value="Não verificado"></v-radio>
      </v-radio-group>

      <v-text-field v-if="dados.sinalizacaoFalhaLocal.$model === 'Sim'" label="Descreva a sinalização de falha apresentada"
        v-model.trim="dados.sinalizacaoFalha.$model" :error-messages="sinalizacaoFalhaErrors"
        placeholder="ex: Fault F005, LED vermelho piscando..." solo></v-text-field>
    </v-col>

    <v-col cols="12" md="4" v-show="ehCategoria(['Automação'])">
      <label>
        Acesso remoto ao equipamento está disponível?
      </label>
      <v-radio-group row v-model="dados.condicoesAcesso.$model" :error-messages="condicoesAcessoErrors">
        <v-radio label="AnyDesk" value="AnyDesk"></v-radio>
        <v-radio label="VPN" value="VPN"></v-radio>
        <v-radio label="Somente presencial" value="Presencial"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('subconjunto')">
      <label for="">Subconjunto / Área
      </label>
      <v-radio-group row v-model.trim="dados.subconjunto.$model" :error-messages="subconjuntoErrors">
        <v-radio label="Entrada" value="Entrada"></v-radio>
        <v-radio label="Barramento" value="Barramento"></v-radio>
        <v-radio label="Saídas" value="Saídas"></v-radio>
        <v-radio label="Supervisão" value="Supervisão"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="4" v-show="isVisible('tensao')">
      <label for="">Tensão nominal
      </label>
      <v-select v-model.trim="dados.tensao.$model" :error-messages="tensaoErrors"
        :items="['127V', '220V', '380V', '13,8kV', '34,5kV', 'Outros']" label="Tensão nominal" solo></v-select>
    </v-col>

    <v-col cols="12" v-show="isVisible('categoriaProblema') && ehCategoria(['Elétrica'])">
      <label for="">O problema surgiu após:</label>
      <v-select v-model.trim="dados.categoriaProblema.$model" :error-messages="categoriaProblemaErrors"
        :items="problemas" label="Selecione uma categoria" solo></v-select>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('existeBackup')">
      <label>
        Existe backup recente da programação do equipamento?
      </label>
      <v-radio-group row v-model="dados.existeBackup.$model" :error-messages="existeBackupErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('existeLogs')">
      <label>
        Existe logs e registros histórico do momento da falha?
      </label>
      <v-radio-group row v-model="dados.existeLogs.$model" :error-messages="existeLogsErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('condicoesAcesso') && ehCategoria(['Civil', 'Infraestrutura', 'Elétrica'])">
      <label>
        O problema representa risco de segurança ou compromete a operação?
      </label>
      <v-radio-group row v-model="dados.condicoesAcesso.$model" :error-messages="condicoesAcessoErrors">
        <v-radio label="Sim" value="Sim"></v-radio>
        <v-radio label="Não" value="Não"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('categoriaProblema') && !ehCategoria(['Elétrica'])">
      <label for="">Descrição do Problema:</label>
      <v-select v-model.trim="dados.categoriaProblema.$model" :error-messages="categoriaProblemaErrors"
        :items="CATEGORIAS_PROBLEMA" label="Selecione uma categoria" solo></v-select>

    </v-col>

    <v-col cols="12" md="4" v-show="isVisible('problemaEvoluindo')">
      <label>
        O problema evoluiu desde que foi identificado?
      </label>
      <v-radio-group row v-model="dados.problemaEvoluindo.$model" :error-messages="problemaEvoluindoErrors">
        <v-radio label="Sim, piorou" value="Sim"></v-radio>
        <v-radio label="Estável" value="Não"></v-radio>
        <v-radio label="Não sei" value="Não sei"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InfoProduto",
  props: {
    dados: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    problemas: [
      "Manobra Elétrica",
      "Manutenção",
      "Evento externo (raio, chuva, etc.)",
      "Sem causa aparente",
      "Outros",
    ],
  }),
  computed: {
    energizadoMomentoFalhaErrors() {
      const errors = [];
      if (!this.dados.energizadoMomentoFalha.$dirty) return errors;
      !this.dados.energizadoMomentoFalha.required && errors.push("Campo obrigatório");
      return errors;
    },
    sinalizacaoFalhaLocalErrors() {
      const errors = [];
      if (!this.dados.sinalizacaoFalhaLocal.$dirty) return errors;
      !this.dados.sinalizacaoFalhaLocal.required && errors.push("Campo obrigatório");
      return errors;
    },
    sinalizacaoFalhaErrors() {
      const errors = [];
      if (!this.dados.sinalizacaoFalha.$dirty) return errors;
      !this.dados.sinalizacaoFalha.required && errors.push("Campo obrigatório");
      return errors;
    },
    condicoesAcessoErrors() {
      const errors = [];
      if (!this.dados.condicoesAcesso.$dirty) return errors;
      !this.dados.condicoesAcesso.required && errors.push("Campo obrigatório");
      return errors;
    },
    subconjuntoErrors() {
      const errors = [];
      if (!this.dados.subconjunto.$dirty) return errors;
      !this.dados.subconjunto.required && errors.push("Campo obrigatório");
      return errors;
    },
    tensaoErrors() {
      const errors = [];
      if (!this.dados.tensao.$dirty) return errors;
      !this.dados.tensao.required && errors.push("Campo obrigatório");
      return errors;
    },
    categoriaProblemaErrors() {
      const errors = [];
      if (!this.dados.categoriaProblema.$dirty) return errors;
      !this.dados.categoriaProblema.required && errors.push("Campo obrigatório");
      return errors;
    },
    existeBackupErrors() {
      const errors = [];
      if (!this.dados.existeBackup.$dirty) return errors;
      !this.dados.existeBackup.required && errors.push("Campo obrigatório");
      return errors;
    },
    existeLogsErrors() {
      const errors = [];
      if (!this.dados.existeLogs.$dirty) return errors;
      !this.dados.existeLogs.required && errors.push("Campo obrigatório");
      return errors;
    },
    umidadeErrors() {
      const errors = [];
      if (!this.dados.umidade.$dirty) return errors;
      !this.dados.umidade.required && errors.push("Campo obrigatório");
      return errors;
    },
    eventoClimaticoErrors() {
      const errors = [];
      if (!this.dados.eventoClimatico.$dirty) return errors;
      !this.dados.eventoClimatico.required && errors.push("Campo obrigatório");
      return errors;
    },
    problemaEvoluindoErrors() {
      const errors = [];
      if (!this.dados.problemaEvoluindo.$dirty) return errors;
      !this.dados.problemaEvoluindo.required && errors.push("Campo obrigatório");
      return errors;
    },
    CATEGORIAS_PROBLEMA() {
      const opcoesPorCategoria = {
        Automação: [
          "Falha de comunicação",
          "Parametrização incorreta",
          "Erro de software",
          "Desarme indevido",
          "Perda de sinal",
          "Outro",
        ],
        Elétrica: [
          "Não energiza",
          "Desarme",
          "Aquecimento",
          "Faísca",
          "Arco elétrico",
          "Ruído anormal",
          "Odor de queimado",
          "Outro",
        ],
        Civil: [
          "Recalque",
          "Trinca ",
          "Alagamento",
          "Corrosão",
          "Desalinhamento",
          "Ruptura",
          "Obstrução",
          "Outro",
        ],
        Infraestrutura: [
          'Corrosão',
          'Deformação',
          'Fratura',
          'Folga',
          'Pintura danificada',
          'Vedação comprometida',
          'Fixação solta',
          'Outro',
        ],
      };
      const categoriaSelecionada =
        this.dados?.categoriaSelecionada?.$model || this.dados?.categoria?.$model || "";
      return opcoesPorCategoria[categoriaSelecionada.split(' ')[0]] || [];
    },
  },
  methods: {
    isVisible(field) {
      const categoriaSelecionada =
        this.dados?.categoriaSelecionada?.$model || this.dados?.categoria?.$model || "";
      const camposPorCategoria = {
        Automação: [
          "energizadoMomentoFalha",
          "sinalizacaoFalha",
          "existeBackup",
          "existeLogs",
          "categoriaProblema",
          "condicoesAcesso"
        ],
        Elétrica: [
          "umidade",
          "eventoClimatico",
          "energizadoMomentoFalha",
          "sinalizacaoFalha",
          "condicoesAcesso",
          "subconjunto",
          "tensao",
          "categoriaProblema",
        ],
        Civil: [
          "umidade",
          "eventoClimatico",
          "condicoesAcesso",
          "categoriaProblema",
          "problemaEvoluindo",
        ],
        Infraestrutura: ["umidade", "eventoClimatico", "condicoesAcesso", "categoriaProblema"],
        Outros: [],
      };

      return Object.keys(camposPorCategoria).some((categoria) => {
        return (
          categoriaSelecionada.includes(categoria) &&
          camposPorCategoria[categoria].includes(field)
        );
      });
    },
    ehCategoria(categorias = []) {
      try {
        return categorias.some((categoria) => {
          return this.dados.categoriaSelecionada.$model.includes(categoria);
        });
      } catch (e) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.form-principal {
  display: flex;
  flex-direction: column;
}

label {
  max-width: 99%;
}

.opcional-container {
  margin: 0px;
  max-width: 100%;
  background-color: #e8e8e8;
  width: 100%;
  padding: 12px 24px;
  margin-bottom: 24px;
}
</style>
